import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { FormTypes } from 'workspace/const'
import { intlShape, injectIntl } from 'react-intl'

const WorkspaceSapImportLegend = ({ formType, intl }) => {
  if (formType !== FormTypes.SAP_IMPORT) {
    return null
  }

  return (
    <div
      className='workspace__extra'
      style={{ justifyContent: 'center', display: 'flex', gap: '40px' }}
    >
      <table
        className='table table--striped'
        style={{ width: 'calc(25% - 20px)' }}
      >
        <thead>
          <tr>
            <th colSpan='2' style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {intl.formatMessage({ id: 'workspace.form.sap_simple_format' })}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>A</td>
            <td>B</td>
          </tr>
          <tr>
            <td>{intl.formatMessage({ id: 'workspace.form.product' })}</td>
            <td>{intl.formatMessage({ id: 'workspace.form.quantity' })}</td>
          </tr>
        </tbody>
      </table>
      <div style={{ borderLeft: '2px solid #ddd', height: 'auto' }} />
      <table
        className='table table--striped'
        style={{ width: 'calc(50% - 20px)' }}
      >
        <thead>
          <tr>
            <th colSpan='9' style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {intl.formatMessage({ id: 'workspace.form.sap_extended_format' })}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>A</td>
            <td>B</td>
            <td>C</td>
            <td>D</td>
            <td>E</td>
            <td>F</td>
            <td>G</td>
            <td>H</td>
            <td>I</td>
          </tr>
          <tr>
            <td>{intl.formatMessage({ id: 'workspace.form.resource' })}</td>
            <td>{intl.formatMessage({ id: 'workspace.form.order_start_date' })}</td>
            <td>{intl.formatMessage({ id: 'workspace.form.order_start_time' })}</td>
            <td>{intl.formatMessage({ id: 'workspace.form.order_end_date' })}</td>
            <td>{intl.formatMessage({ id: 'workspace.form.order_end_time' })}</td>
            <td>{intl.formatMessage({ id: 'workspace.form.product_number' })}</td>
            <td>{intl.formatMessage({ id: 'workspace.form.product_short_description' })}</td>
            <td>{intl.formatMessage({ id: 'workspace.form.receipt_quantity' })}</td>
            <td>{intl.formatMessage({ id: 'workspace.form.base_unit_of_measure' })}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

WorkspaceSapImportLegend.propTypes = {
  formType: PropTypes.string,
  intl: intlShape
}

const mapStateToProps = state => ({
  formType: state.form.type
})

export default compose(connect(mapStateToProps), injectIntl)(WorkspaceSapImportLegend)
